import ApiService from '../../../core/services/ApiService';

export interface EngagementDto {
  id: number;
  engagementId: string;
  engagementType: string;
  description: string;
  taxYear: number;
  status: string;
}

export interface CreateEngagementDto {
  engagementType: string;
  description: string;
  taxYear: number;
}

class EngagementService extends ApiService {
  getEngagements(clientTenantId?: string | number): Promise<EngagementDto[]> {
    return this.makeRequest<EngagementDto[]>('/api/engagement', {
      extractData: true,
      overrideTenant: clientTenantId !== undefined ? String(clientTenantId) : undefined,
    });
  }

  createEngagement(dto: CreateEngagementDto, clientTenantId?: string | number): Promise<EngagementDto> {
    return this.makeRequest<EngagementDto>('/api/engagement', {
      method: 'POST',
      data: dto as any,
      extractData: true,
      overrideTenant: clientTenantId !== undefined ? String(clientTenantId) : undefined,
    });
  }
}

const engagementService = new EngagementService();
export default engagementService;
